/**
 * Job Listings Block
 *
 * Handles AJAX filtering, clearing and numbered pagination for the job board.
 */

function initJobListings(root) {
  const form = root.querySelector(".job-listings__filters");
  const list = root.querySelector(".job-listings__list");
  const countEl = root.querySelector(".job-listings__count");
  const pager = root.querySelector(".job-listings__pagination");

  if (!form || !list || typeof ajax_params === "undefined") return;

  const state = { page: 1, loading: false };

  function collectFilters() {
    const data = new FormData(form);
    return {
      search: (data.get("search") || "").toString().trim(),
      service_line: data.get("service_line") || "all",
      location: data.get("location") || "all",
      practice: data.get("practice") || "all",
    };
  }

  function fetchJobs(page) {
    if (state.loading) return;
    state.loading = true;
    state.page = page;

    const filters = collectFilters();
    const body = new FormData();
    body.append("action", "version1_job_listings");
    body.append("page", page);
    body.append("block_theme", root.dataset.blockTheme || "");
    Object.keys(filters).forEach((key) => body.append(key, filters[key]));

    root.classList.add("is-loading");

    fetch(ajax_params.ajax_url, {
      method: "POST",
      body,
      credentials: "same-origin",
    })
      .then((r) => r.json())
      .then((data) => {
        if (!data.success) return;
        list.innerHTML = data.data.rows;
        if (countEl) countEl.textContent = data.data.count;
        if (pager) pager.innerHTML = data.data.pagination;
        root.scrollIntoView({ behavior: "smooth", block: "start" });
      })
      .finally(() => {
        state.loading = false;
        root.classList.remove("is-loading");
      });
  }

  // Search on submit (Enter key) and on the Search button (an anchor).
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    fetchJobs(1);
  });

  const submitButton = root.querySelector(".job-listings__submit");
  if (submitButton) {
    submitButton.addEventListener("click", (e) => {
      e.preventDefault();
      fetchJobs(1);
    });
  }

  // Clear filters — reset the form (and Select2) then refetch.
  const clearButton = root.querySelector(".job-listings__clear");
  if (clearButton) {
    clearButton.addEventListener("click", () => {
      form.reset();
      if (window.jQuery) {
        window.jQuery(form).find("select").val("all").trigger("change.select2");
      }
      fetchJobs(1);
    });
  }

  // Numbered pagination (delegated — markup is replaced on each fetch).
  if (pager) {
    pager.addEventListener("click", (e) => {
      const target = e.target.closest("[data-page]");
      if (!target) return;
      e.preventDefault();
      const page = parseInt(target.getAttribute("data-page"), 10) || 1;
      fetchJobs(page);
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".job-listings").forEach(initJobListings);
});

// Re-initialize in the block editor preview.
document.addEventListener("blockEditorInit", (e) => {
  const block = e.detail && e.detail.block;
  if (block) {
    block.querySelectorAll(".job-listings").forEach(initJobListings);
  }
});
